import React, { useState } from "react"
import { Mail, Globe, ArrowRight, CheckCircle } from "lucide-react"
import { useTranslation } from "react-i18next"
import { Button } from "./ui/button"
import { useScrollAnimation } from "../hooks/useScrollAnimation"

export default function Waitlist() {
    const { t } = useTranslation()
    const ref = useScrollAnimation()
    const [email, setEmail] = useState("")
    const [country, setCountry] = useState("")
    const [submitted, setSubmitted] = useState(false)

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault()
        // Here you would typically send the data to your backend
        console.log({ email, country })
        setSubmitted(true)
        setTimeout(() => {
            setEmail("")
            setCountry("")
            setSubmitted(false)
        }, 3000)
    }

    return (
        <section id="waitlist" ref={ref} className="scroll-animate py-20 bg-gradient-to-br from-blue-600 to-indigo-700">
            <div className="container mx-auto px-4 md:px-6">
                <div className="max-w-2xl mx-auto text-center">
                    {/* Title */}
                    <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                        {t('waitlist.title')}
                    </h2>

                    {/* Description */}
                    <p className="text-lg text-blue-100 mb-10">
                        {t('waitlist.description')}
                    </p>

                    {/* Form */}
                    {!submitted ? (
                        <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-2xl p-8 md:p-10">
                            <div className="space-y-5 mb-6">
                                {/* Email Input */}
                                <div className="relative">
                                    <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                                    <input
                                        type="email"
                                        required
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder={t('waitlist.emailPlaceholder')}
                                        className="w-full pl-12 pr-4 py-4 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900 placeholder-gray-400"
                                    />
                                </div>

                                {/* Country Input */}
                                <div className="relative">
                                    <Globe className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                                    <input
                                        type="text"
                                        value={country}
                                        onChange={(e) => setCountry(e.target.value)}
                                        placeholder={t('waitlist.countryPlaceholder')}
                                        className="w-full pl-12 pr-4 py-4 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900 placeholder-gray-400"
                                    />
                                </div>
                            </div>

                            {/* Submit Button */}
                            <Button
                                type="submit"
                                size="lg"
                                className="w-full h-14 text-base font-semibold"
                            >
                                {t('waitlist.button')}
                                <ArrowRight className="ml-2 w-5 h-5" />
                            </Button>

                            {/* Privacy Note */}
                            <p className="mt-6 text-sm text-gray-500">
                                {t('waitlist.privacy')}
                            </p>
                        </form>
                    ) : (
                        <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-10">
                            <div className="flex flex-col items-center justify-center py-8">
                                <CheckCircle className="w-16 h-16 text-green-500 mb-4" />
                                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                                    {t('waitlist.successTitle')}
                                </h3>
                                <p className="text-gray-600">
                                    {t('waitlist.successMessage')}
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    )
}
